import {Injectable} from '@angular/core';
import {Request,Headers,Response} from '@angular/http';
import {HttpClient} from '../../../services/http.service';
import{AppConstants} from '../../../app.constants';
import { LocalStorageService } from 'ng2-webstorage';
import{Observable}from 'rxjs/Rx';
@Injectable()
export class UserService{

    constructor(private httpClient: HttpClient, private appConstants: AppConstants,private localStorage:LocalStorageService ){

}

    public getUserRole(userId): Observable<Response>{
        return this.httpClient.Get(userId)
    }

    public getSchoolUser(pagenum, searchString): Observable<Response> {
        if (!searchString) {
            var url: string = '' + this.appConstants.baseUrl + this.appConstants.schoolUsers + '?token=' + this.localStorage.retrieve('Token') +'&PageSize=' + 10 + '&pageNumber=' + pagenum;
        }
        else {
            var url: string = '' + this.appConstants.baseUrl + this.appConstants.schoolUsers + '?token=' + this.localStorage.retrieve('Token') + '&searchString='+searchString+ '&PageSize=' + 10 + '&pageNumber=' + pagenum;
        }

        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError)
    }


  public getSchoolUserQuanta(pagenum, searchString): Observable<Response> {
    if (!searchString) {
      var url: string = '' + this.appConstants.baseUrl + this.appConstants.schoolUsers + '?token=' + this.localStorage.retrieve('auth_token') +'&PageSize=' + 10 + '&pageNumber=' + pagenum;
    }
    else {
      var url: string = '' + this.appConstants.baseUrl + this.appConstants.schoolUsers + '?token=' + this.localStorage.retrieve('auth_token') + '&searchString='+searchString+ '&PageSize=' + 10 + '&pageNumber=' + pagenum;
    }

    return this.httpClient.Get(url)
      .map(this.extractData)
      .catch(this.handleError)
  }


    public deleteUserEntry(userId): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + this.appConstants.deleteUser + '?Id=' + userId + '&TokenId=' + this.localStorage.retrieve('Token');
        return this.httpClient.Post(url,userId)
            .map(this.extractData)
            .catch(this.handleError)
    }


  public deleteUserEntryQuanta(userId): Observable<Response> {
    let url: string = '' + this.appConstants.baseUrl + this.appConstants.deleteUser + '?Id=' + userId + '&TokenId=' + this.localStorage.retrieve('auth_token');
    return this.httpClient.Post(url,userId)
      .map(this.extractData)
      .catch(this.handleError)
  }




  private extractData(res:Response){
    let body = res.json();
    return body;
}

private handleError(error:any){
    let errMsg = (error.message) ? error.message :
    error.status ? `${error.status} - ${error.statusText}` : 'Server error';
let err = JSON.parse(error._body);
return Observable.throw(err);
}
}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/components/manageuser/user/user.service.ts